import { useCallback, useState } from "react";
import {
  QueryFunction,
  QueryKey,
  QueryObserverOptions,
  useQuery,
} from "react-query";

export function useQuerySubscription<T>(
  queryKey: QueryKey,
  queryFn: QueryFunction<T>,
  queryOptions?: QueryObserverOptions
) {
  const options = { enabled: true, ...queryOptions };
  const [subsCount, setSubsCount] = useState(0);
  const subscribe = useCallback(() => setSubsCount((val) => val + 1), []);
  const unsubscribe = useCallback(() => setSubsCount((val) => val - 1), []);
  const query = useQuery(queryKey, queryFn, {
    enabled: options.enabled && subsCount > 0,
  });
  return { query, subscribe, unsubscribe };
}
